import { CreateConversationRequest } from '@repo/shared/src/back/back-messages.types';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
  ConversationsResponse,
  CreateConversationResponse,
} from '@repo/shared/src/services/messaging-service/messaging-service.types';
import { Observable } from 'rxjs';
import { BACK_API_URL } from '../../app.tokens';
import { HostChannelService } from './host-channel.service';
import { SupportedChannelMessageEnum } from '../helpers/supported-channel-message.enum';
import { IdentityProviderMessagingTokenResponse } from '@repo/shared/src/services/identity-provider/identity-provider.types';

@Injectable({
  providedIn: 'root',
})
export class ConversationService {
  constructor(
    @Inject(BACK_API_URL) private readonly API_URL: string,
    private readonly http: HttpClient,
    private readonly hostChannelService: HostChannelService,
  ) {}

  getConversationList(): Observable<ConversationsResponse> {
    return this.http.get<ConversationsResponse>(`${this.API_URL}/conversations`);
  }

  postConversation(conversation: CreateConversationRequest): Observable<CreateConversationResponse> {
    return this.http.post<CreateConversationResponse>(`${this.API_URL}/conversations`, conversation);
  }

  patchConversation(changes: any, conversationId: string): Observable<CreateConversationResponse> {
    return this.http.patch<CreateConversationResponse>(`${this.API_URL}/conversations/${conversationId}`, changes);
  }

  deleteConversationById(id: string): Observable<any> {
    return this.http.delete(`${this.API_URL}/conversations/${id}`);
  }

  exportConversation(id: string, hasAttachments: boolean) {
    let headers = new HttpHeaders();
    if (hasAttachments) {
      headers = headers.set('accept', 'application/zip');
    } else {
      headers = headers.set('accept', 'application/pdf');
    }
    return this.http.get(`${this.API_URL}/conversations/${id}`, { headers: headers, responseType: 'blob' });
  }

  exportConversationMobile(id: string, hasAttachments: boolean, token: IdentityProviderMessagingTokenResponse | null) {
    let extension = '.pdf';
    if (hasAttachments) extension = '.zip';
    this.hostChannelService.postMessage({
      type: SupportedChannelMessageEnum.DOWNLOAD_FILE,
      data: {
        filename: 'conversation-' + id + extension,
        contentType: hasAttachments ? 'application/zip' : 'application/pdf',
        url: `${this.API_URL}/conversations/${id}`,
        token: token?.data?.accessToken,
        /* token: this.webStorage.getInSession<any>('tokenResponse')?.data?.accessToken, */
      },
    });
  }
}
